import React from "react";
import { Container } from "@mui/material";

const ContentContainer = ({ children }) => {
  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: "1024px",
        pt: 1.875, // 15px
        px: 1.875, // 30px
        pb: 6.25, // 50px
      }}
    >
      {children}
    </Container>
  );
};

export default ContentContainer;
